export const COLOR_THEME_OPTIONS = [
  "blue",
  "purple",
  "green",
  "red",
  "orange",
  "teal",
  "indigo",
  "pink",
  "cyan",
  "amber",
];

export const COLOR_THEME_PRESETS = {
  blue: {
    swatch: "#2F6BFF",
    token: {
      colorPrimary: "#2F6BFF",
      colorTextHeading: "#2F6BFF",
      colorBorder: "#2F6BFF55",
    },
  },
  purple: {
    swatch: "#8B5CF6",
    token: {
      colorPrimary: "#8B5CF6",
      colorTextHeading: "#8B5CF6",
      colorBorder: "#8B5CF655",
    },
  },
  green: {
    swatch: "#22C55E",
    token: {
      colorPrimary: "#22C55E",
      colorTextHeading: "#22C55E",
      colorBorder: "#22C55E55",
    },
  },
  red: {
    swatch: "#FF3B30",
    token: {
      colorPrimary: "#FF3B30",
      colorTextHeading: "#FF3B30",
      colorBorder: "#FF3B3055",
    },
  },
  orange: {
    swatch: "#FF7A1A",
    token: {
      colorPrimary: "#FF7A1A",
      colorTextHeading: "#FF7A1A",
      colorBorder: "#FF7A1A55",
    },
  },
  teal: {
    swatch: "#00A6A6",
    token: {
      colorPrimary: "#00A6A6",
      colorTextHeading: "#00A6A6",
      colorBorder: "#00A6A655",
    },
  },
  indigo: {
    swatch: "#6D5DF6",
    token: {
      colorPrimary: "#6D5DF6",
      colorTextHeading: "#6D5DF6",
      colorBorder: "#6D5DF655",
    },
  },
  pink: {
    swatch: "#F43F8B",
    token: {
      colorPrimary: "#F43F8B",
      colorTextHeading: "#F43F8B",
      colorBorder: "#F43F8B55",
    },
  },
  cyan: {
    swatch: "#00B8D9",
    token: {
      colorPrimary: "#00B8D9",
      colorTextHeading: "#00B8D9",
      colorBorder: "#00B8D955",
    },
  },
  amber: {
    swatch: "#F59E0B",
    token: {
      colorPrimary: "#F59E0B",
      colorTextHeading: "#F59E0B",
      colorBorder: "#F59E0B55",
    },
  },
};

export const COLOR_THEME_TOKENS = Object.fromEntries(
  COLOR_THEME_OPTIONS.map((color) => [color, COLOR_THEME_PRESETS[color].token]),
);
